import React from 'react';
import { uploadFile } from '../API/API';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Layout from './Layout';

const useStyles = makeStyles((theme) => ({
  content: {
    margin: theme.spacing(2),
    maxWidth: 1200,
  },
  title: {
    padding: 0,
    margin: 0,
    paddingTop: theme.spacing(0.5),
    height: theme.spacing(5),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

export default function UploadDocumentDialog({ open, line, handleClose }) {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();

  return (
    <Dialog
      fullWidth
      fullScreen={mobile}
      open={open}
      onClose={() => handleClose()}
    >
      <DialogTitle className={classes.title} disableTypography>
        <IconButton
          className={classes.closeButton}
          onClick={() => handleClose()}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <div className={classes.content}>
        <Layout
          onSubmit={async (file) => {
            uploadFile(line, file)
              .then(() => handleClose('success'))
              .catch(() => handleClose('error'));
          }}
        />
      </div>
    </Dialog>
  );
}
